/* 🔴 **`@fontsource/roboto` の読み込みを外しました**（8/22・コードレビュー対応）
      Roboto は `variable.css` のどの `--font-*` にも入っておらず、
      **読み込んで一度も使っていません**でした。テンプレートの名残です。
   ⚠ 書き戻さないこと。使っていないフォントを1書体ぶん取りに行くだけになります。

   フォントの読み込みは `gatsby-ssr.js` にまとめてあります。 */
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/motion.css"
/* 🔴 **切り絵のテクスチャ**（8/20・内製さんのご要望）。
      ⚠ motion.css より**あと**に読ませること。
         浮く絵（.float）のフィルターを打ち消す指定が入っています */
import "./src/styles/foundation/papercut.css"
import "./src/styles/foundation/blog-contents-style.css"

/* ============================================================
 * 🔴 **お知らせ・ブログのタブを押しても、上に飛ばないようにします**
 *    （8/25・AUN #32）
 *
 *    > それぞれをクリックすると、毎回ページの頭に戻ってしまうのですが、
 *    > ここ（タブの部分）に留めておくことはできますか？
 *
 * ■ なぜ飛ぶのか
 *     Gatsby は**ページを移ると必ずいちばん上へスクロールし直します**。
 *     タブは `<Link>` で `/news/p/1/` ⇄ `/news/c/blog/p/1/` と
 *     **ページを移っている**ので、毎回上に戻っていました。
 *     （8/22 に `window.location.reload()` は外して白い点滅は消えましたが、
 *     　上に戻る動き自体はGatsbyの既定のままでした）
 *
 * ■ 直し方
 *     一覧どうしの移動のときだけ `false` を返して、
 *     **いまいる位置にとどまらせます。**
 *     タブより上（大見出し・「未就園児クラスや〜」の帯）は
 *     どのカテゴリでも同じ高さなので、**タブは同じ位置に残ります。**
 *
 * ⚠ 記事の本文へ移るときは `true`（＝上に戻る）のままにすること。
 *    ここで一律 `false` にすると、記事を開いても途中から始まります。
 * ⚠ 判定はURLの形（`/p/数字/` で終わる）で見ています。
 *    管理画面でスラッグを変えても付いていけます。
 * ============================================================ */
const LIST_PATH = /\/(?:c\/[^/]+\/)?p\/\d+\/?$/

export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  const to = routerProps?.location?.pathname || ""
  const from = prevRouterProps?.location?.pathname || ""

  /* 一覧 → 一覧（タブの押し替え・ページ送り）だけ、その場にとどまる */
  if (LIST_PATH.test(to) && LIST_PATH.test(from)) {
    const toBase = to.split("/")[1]
    const fromBase = from.split("/")[1]
    if (toBase && toBase === fromBase) return false
  }

  return true
}
